import script from "./SchoolsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolsPage.vue?vue&type=script&setup=true&lang=js"

import "./SchoolsPage.vue?vue&type=style&index=0&id=4778ae72&lang=css"

const __exports__ = script;

export default __exports__